import { useState } from 'react';

const STORAGE_KEY = 'golfamore-web-sales.';

const useSessionStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.sessionStorage.getItem(STORAGE_KEY + keyName);

      if (value) {
        const data = JSON.parse(value);
        // We consider the data to be valid in 30 minutes, after that return null
        const timeDiffInMinutes = Math.round((Date.now() - data.timestamp) / (1000 * 60));
        if (timeDiffInMinutes > 30) {
          return null;
        }

        return data;
      }
      window.sessionStorage.setItem(STORAGE_KEY + keyName, JSON.stringify(defaultValue));
      return defaultValue;
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY + keyName, JSON.stringify({ ...newValue, timestamp: Date.now() }));
    } catch (err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};

export default useSessionStorage;
